"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var Sitemap =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Sitemap, _Record);

  function Sitemap() {
    (0, _classCallCheck2.default)(this, Sitemap);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Sitemap).apply(this, arguments));
  }

  return Sitemap;
}((0, _immutable.Record)({
  id: null,
  name: null,
  domain: null,
  portalId: null,
  pagesTree: null,
  hasUserChanges: null,
  created: null,
  updated: null,
  deletedAt: null,
  initiatedAt: null,
  blogPosts: null,
  sitePages: null,
  landingPages: null,
  knowledgeArticles: null,
  contentOptions: null
}, 'Sitemap'));

exports.default = Sitemap;
module.exports = exports.default;